import VNavLink from './VNavLink.vue';

export { VNavLink };
export default VNavLink;
